<ng-container *ngIf="docData">
  <div class="DocumentViewer" [ngClass]="currentUser?.UserType">
    <div class="Wrap">
      <div class="Content">
        <document-desktop
          *ngIf="!isMobile()"
          [docData]="docData"
          [similarDocs]="similarDocs"
          [authorDetail]="authorDetail"></document-desktop>
        <document-mobile *ngIf="isMobile()" [docData]="docData" [similarDocs]="similarDocs" [authorDetail]="authorDetail"></document-mobile>
      </div>
    </div>
  </div>
</ng-container>
